import React from "react";
import { _goToProduct } from "routers/helper";

import { View, StyleSheet, TouchableOpacity } from "react-native";

import Icon from "components/Icon";
import Text from "components/Text";

import { colors, sizes, strings } from "assets/constants";
import { useRecoilValue } from "recoil";
import { authAtom } from "stores";

export default function ProductBox(props: { product: ProductT }) {
  const {
    company: { color },
  } = useRecoilValue(authAtom);

  const { id, title, is_active, category, discount } = props.product;

  const _goToEdit = () => id && _goToProduct({ id, catId: category?.id });

  return (
    <TouchableOpacity
      activeOpacity={sizes.tapOpacity}
      style={styles.container}
      onPress={_goToEdit}
    >
      <View style={styles.header}>
        <Icon style={{ left: -5 }} size={22} name="chevron-left" />
        <View style={styles.titleContainer}>
          <Text
            numberOfLines={1}
            style={{ lineHeight: 20 }}
            weight="bold"
            size="lg"
            color={colors.textColorDark}
          >
            {title}
          </Text>
        </View>
      </View>

      <View style={styles.footer}>
        {is_active === 0 && (
          <View
            style={{
              left: -3,
              height: 20,
              borderRadius: 10,
              paddingHorizontal: 5,
              backgroundColor: colors.lightButtons,
              marginRight: 10,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text color={colors.danger} size={"xs"} weight="bold">
              {strings.inactive}
            </Text>
          </View>
        )}

        {discount === 1 && (
          <View
            style={{
              left: -3,
              height: 20,
              borderRadius: 10,
              paddingHorizontal: 5,
              backgroundColor: colors.lightButtons,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text color={colors.success} size={"xs"} weight="bold">
              {strings.discounted}
            </Text>
          </View>
        )}

        <View style={{ width: 15 }} />
        <View style={styles.title}>
          <Text numberOfLines={1} weight="medium">
            {category?.title || strings.without_cat}
          </Text>
        </View>
        <Icon color={color} size={15} type="antDesign" name={"appstore-o"} />
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    width: "100%",
    borderRadius: sizes.radius.xl,
    backgroundColor: colors.itemsBg,
    paddingHorizontal: sizes.space,
    paddingVertical: 7,
  },

  header: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 10,
    height: 25,
  },

  type: { flexDirection: "row", alignItems: "center" },

  titleContainer: { flex: 1, alignItems: "flex-end" },

  footer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  title: { flexGrow: 1, marginHorizontal: 6 },
});
